import icon from './icon.vue'
icon.install = function (Vue) {
  Vue.component(icon.name, icon);
};
export default icon



// WEBPACK FOOTER //
// ./src/ni-ui/icon/index.js